import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router, RouterModule } from "@angular/router";
import { CommonModule, DatePipe, Location } from "@angular/common";
import { forkJoin } from 'rxjs';
import { CustomsClearanceHeader } from "../models/customs-clearance-header.model";
import { CustomsClearanceEndpointService } from "../clearance.service";
import { CustomsClearanceDetail } from "../models/customs-clearance.detail";
import { CustomsClearanceContacts } from "../models/customs-clearance-contact.model";
import { UserRole } from "../../models/common/user-role";
import { ClearanceDownloadUrlCallback } from "../../services/google/google-cloud-storage.service";
import { SessionStorageService } from "../../services/session-storage.service";
import { DialogService } from "primeng/dynamicdialog";
import { ClearanceFileUploadComponent } from "../../helpers/clearance-file-upload/clearance-file-upload.component";
import { CustomsClearanceFile } from "../models/customs-clearance-file.model";
import { ToastModule } from "primeng/toast";
import { ProgressBarModule } from "primeng/progressbar";
import { TagModule } from "primeng/tag";
import { ButtonModule } from "primeng/button";
import { FileUploadModule } from "primeng/fileupload";
import { AddEditClearanceChargesComponent } from "../add-edit-clearance-charges/add-edit-clearance-charges.component";
import { TableModule } from "primeng/table";
import { ChipModule } from "primeng/chip";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClearanceStatus } from '../models/clearance-status.enum';
import { PermissionService } from 'src/app/security/permission.service';
import { app_permissions } from 'src/app/security/app-permissions';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { SelectModule } from 'primeng/select';
import { PageShellComponent } from '../../shared/page-layout/page-shell.component';
import { PageDetailHeroComponent } from '../../shared/page-layout/page-detail-hero.component';
import { PageMetricStripComponent } from '../../shared/page-layout/page-metric-strip.component';
import { PageDataPanelComponent } from '../../shared/page-layout/page-data-panel.component';
import { PageMetric } from '../../shared/page-layout/page-layout.models';
import { CustomsDeclaration } from '../models/customs-declaration.model';
import { CustomsDeclarationItem } from '../models/customs-declaration-item.model';
import { CustomsComplianceDocument } from '../models/customs-compliance-document.model';
import { CustomsClearanceFileTypes } from '../models/customs-clearance-file-type';
import { CustomsBrokerAuthorization } from '../models/customs-broker-authorization.model';
import { CustomsActivityLog } from '../models/customs-activity-log.model';
import { CustomsClearanceRelatedResource } from '../models/customs-clearance-related-resource.model';
import { ClearanceReadiness } from '../models/clearance-readiness.model';
import { ProductivityIncident, ProductivityNotification, ProductivityTask } from 'src/app/productivity/productivity.model';
import { ProductivityService } from 'src/app/productivity/productivity.service';
import { CustomsDutyTaxAssessment } from '../models/customs-duty-tax-assessment.model';
import { CustomsPaymentReceipt } from '../models/customs-payment-receipt.model';
import { CustomsContainer } from '../models/customs-container.model';
import { ClearanceFinancialSummary } from '../models/clearance-financial-summary.model';
import { ClearanceExecutionReadiness } from '../models/clearance-execution-readiness.model';
import { CustomsIntegrationStatus } from '../models/customs-integration-status.model';
import { CustomsIntegrationEvent } from '../models/customs-integration-event.model';
import { ClearanceIntegrationSummary } from '../models/clearance-integration-summary.model';
import { CustomsProcedureCase } from '../models/customs-procedure-case.model';
import { CustomsGuaranteeDeposit } from '../models/customs-guarantee-deposit.model';
import { CustomsProcedureClosureEvent } from '../models/customs-procedure-closure-event.model';
import { ClearanceAccountingLink } from '../models/clearance-accounting-link.model';
import { ClearanceModuleLinks, ClearanceTypedModuleLink } from '../models/clearance-module-links.model';
import { ClearanceWorkspaceSummary } from '../models/clearance-workspace-summary.model';
import { WorkflowPanelComponent } from 'src/app/workflow/workflow-panel/workflow-panel.component';
import { FirebaseStorageService } from 'src/app/services/firebase-storage.service';
import { Country } from 'src/app/models/common/country.model';
import { WarehousingMasterData } from 'src/app/warehousing/warehousing.model';
import { WarehousingService } from 'src/app/warehousing/warehousing.service';
import { ShipmentService } from 'src/app/shipment/shipment.service';
import { Shipment } from 'src/app/shipment/models/shipment';
import { FieldResourcesPanelComponent } from 'src/app/field-work/field-resources-panel.component';
import { ExecutionSalesOrderButtonComponent } from '../../order/sales-order/execution-sales-order-button.component';

@Component({
    selector: 'app-view-clearance',
    templateUrl: './view-clearance.component.html',
    styleUrls: ['./view-clearance.component.css'],
    standalone: true,
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ProgressBarModule,
    TagModule,
    ButtonModule,
    FileUploadModule,
    AddEditClearanceChargesComponent,
    TableModule,
    ChipModule,
    RouterModule,
    InputTextModule,
    DialogModule,
    IftaLabelModule,
    InputGroupModule,
    InputGroupAddonModule,
    SelectModule,
    PageShellComponent,
    PageDetailHeroComponent,
    PageMetricStripComponent,
    PageDataPanelComponent,
    WorkflowPanelComponent,
    FieldResourcesPanelComponent,
    ExecutionSalesOrderButtonComponent
],
    providers: [
        MessageService,
        CustomsClearanceEndpointService,
        SessionStorageService,
        DialogService,
        DatePipe
    ]
})
export class ViewClearanceComponent implements OnInit {
    
    canEditClearance = false;
    canCreateClearance = false;
    canUploadFile = false;
    canManageCharges = false;
    canUpdateStatus = false;
    clearanceId!: number;
    clearance!: CustomsClearanceHeader;
    isLoading: boolean = false;
    clearanceAiSummary: string = "";
    people: CustomsClearanceContacts[] = []
    chargeDialogVisible: boolean = false;
    selectedCharge: CustomsClearanceDetail | undefined;
    activeWorkspaceTab: string = 'overview';
    activeEntryDialog: string | null = null;
    declarations: CustomsDeclaration[] = [];
    selectedDeclaration?: CustomsDeclaration;
    declarationDraft: CustomsDeclaration = {};
    declarationItems: CustomsDeclarationItem[] = [];
    itemDraft: CustomsDeclarationItem = {};
    complianceDocuments: CustomsComplianceDocument[] = [];
    documentDraft: CustomsComplianceDocument = { required: true, status: 'MISSING' };
    documentUploadProgress: number = 0;
    readonly customsClearanceFileTypes = CustomsClearanceFileTypes;
    brokerAuthorizations: CustomsBrokerAuthorization[] = [];
    authorizationDraft: CustomsBrokerAuthorization = { status: 'ACTIVE', source: 'MANUAL' };
    activity: CustomsActivityLog[] = [];
    relatedResources: CustomsClearanceRelatedResource[] = [];
    relatedResourceDraft: CustomsClearanceRelatedResource = {};
    procedureCases: CustomsProcedureCase[] = [];
    procedureDraft: CustomsProcedureCase = { procedureMode: 'GCC_TRANSIT', status: 'OPEN', closureStatus: 'OPEN' };
    guaranteeDeposits: CustomsGuaranteeDeposit[] = [];
    guaranteeDraft: CustomsGuaranteeDeposit = { guaranteeType: 'SECURITY_DEPOSIT', currencyCode: 'SAR', status: 'ACTIVE' };
    closureEvents: CustomsProcedureClosureEvent[] = [];
    closureEventDraft: CustomsProcedureClosureEvent = { eventType: 'CLOSURE_EVIDENCE', status: 'RECORDED' };
    selectedProcedureCase?: CustomsProcedureCase;
    accountingLinks: ClearanceAccountingLink[] = [];
    moduleLinks?: ClearanceModuleLinks;
    shipmentLinkDraft?: number;
    readiness?: ClearanceReadiness;
    executionReadiness?: ClearanceExecutionReadiness;
    financialSummary?: ClearanceFinancialSummary;
    dutyTaxAssessments: CustomsDutyTaxAssessment[] = [];
    assessmentDraft: CustomsDutyTaxAssessment = { currencyCode: 'SAR', assessmentStatus: 'ASSESSED', paymentMode: 'IMPORTER_ACCOUNT' };
    paymentReceipts: CustomsPaymentReceipt[] = [];
    receiptDraft: CustomsPaymentReceipt = { currencyCode: 'SAR', paymentType: 'IMPORT_DUTY', status: 'PAID' };
    customsContainers: CustomsContainer[] = [];
    containerDraft: CustomsContainer = { customsReleaseStatus: 'PENDING', lineStatus: 'PENDING' };
    integrationStatuses: CustomsIntegrationStatus[] = [];
    integrationEvents: CustomsIntegrationEvent[] = [];
    integrationSummary?: ClearanceIntegrationSummary;
    integrationDraft: CustomsIntegrationStatus = { provider: 'FASAH', externalStatus: 'DRAFT', internalStatus: 'WARNING', active: true, retryCount: 0 };
    countries: Country[] = [];
    currencyOptions: { label: string; value: string }[] = [];
    warehouseOptions: WarehousingMasterData[] = [];
    shipmentOptions: Shipment[] = [];
    integrationProviders = [
        { key: 'FASAH', label: 'Fasah' },
        { key: 'BAYAN', label: 'Bayan' },
        { key: 'ZATCA_TARIFF', label: 'ZATCA Tariff' },
        { key: 'SABER', label: 'Saber' }
    ];
    transportModeOptions = [
        { label: 'Sea', value: 'SEA' },
        { label: 'Air', value: 'AIR' },
        { label: 'Road', value: 'ROAD' },
        { label: 'Rail', value: 'RAIL' },
        { label: 'Courier', value: 'COURIER' }
    ];
    portTypeOptions = [
        { label: 'Sea Port', value: 'SEA' },
        { label: 'Airport', value: 'AIR' },
        { label: 'Land Port', value: 'LAND' },
        { label: 'Dry Port', value: 'DRY_PORT' },
        { label: 'Free Zone', value: 'FREE_ZONE' }
    ];
    customsPaymentModeOptions = [
        { label: 'Importer Account', value: 'IMPORTER_ACCOUNT' },
        { label: 'Broker Account', value: 'BROKER_ACCOUNT' },
        { label: 'Company Account', value: 'COMPANY_ACCOUNT' },
        { label: 'Cash', value: 'CASH' },
        { label: 'Bank Transfer', value: 'BANK_TRANSFER' },
        { label: 'Deferred Payment', value: 'DEFERRED_PAYMENT' }
    ];
    customsStatusOptions = [
        { label: 'Draft', value: 'DRAFT' },
        { label: 'Submitted', value: 'SUBMITTED' },
        { label: 'Accepted', value: 'ACCEPTED' },
        { label: 'Inspection', value: 'INSPECTION' },
        { label: 'Duty Assessed', value: 'DUTY_ASSESSED' },
        { label: 'Paid', value: 'PAID' },
        { label: 'Released', value: 'RELEASED' },
        { label: 'Re-exported', value: 'RE_EXPORTED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    brokerAuthorizationStatusOptions = [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Expired', value: 'EXPIRED' },
        { label: 'Revoked', value: 'REVOKED' },
        { label: 'Pending', value: 'PENDING' }
    ];
    brokerLicenseTypeOptions = [
        { label: 'Customs Broker', value: 'CUSTOMS_BROKER' },
        { label: 'Forwarder Broker', value: 'FORWARDER_BROKER' },
        { label: 'Importer Representative', value: 'IMPORTER_REPRESENTATIVE' },
        { label: 'Manual Demo', value: 'MANUAL_DEMO' }
    ];
    containerTypeOptions = [
        { label: '20GP', value: '20GP' },
        { label: '40GP', value: '40GP' },
        { label: '40HC', value: '40HC' },
        { label: '45HC', value: '45HC' },
        { label: '20RF', value: '20RF' },
        { label: '40RF', value: '40RF' },
        { label: 'LCL', value: 'LCL' }
    ];
    containerLineStatusOptions = [
        { label: 'Pending', value: 'PENDING' },
        { label: 'Released', value: 'RELEASED' },
        { label: 'Hold', value: 'HOLD' },
        { label: 'Closed', value: 'CLOSED' }
    ];
    containerCustomsReleaseStatusOptions = [
        { label: 'Pending', value: 'PENDING' },
        { label: 'Released', value: 'RELEASED' },
        { label: 'Cleared', value: 'CLEARED' },
        { label: 'On Hold', value: 'ON_HOLD' },
        { label: 'Rejected', value: 'REJECTED' }
    ];
    containerHoldTypeOptions = [
        { label: 'None', value: 'NONE' },
        { label: 'Customs Hold', value: 'CUSTOMS_HOLD' },
        { label: 'Line Hold', value: 'LINE_HOLD' },
        { label: 'Inspection Hold', value: 'INSPECTION_HOLD' },
        { label: 'Payment Hold', value: 'PAYMENT_HOLD' },
        { label: 'Document Hold', value: 'DOCUMENT_HOLD' }
    ];
    containerInspectionStatusOptions = [
        { label: 'Pending', value: 'PENDING' },
        { label: 'Waived', value: 'WAIVED' },
        { label: 'Required', value: 'REQUIRED' },
        { label: 'Scheduled', value: 'SCHEDULED' },
        { label: 'Completed', value: 'COMPLETED' },
        { label: 'Failed', value: 'FAILED' }
    ];
    procedureModeOptions = [
        { label: 'GCC Transit', value: 'GCC_TRANSIT' },
        { label: 'Bonded Zone Entry', value: 'BONDED_ZONE_ENTRY' },
        { label: 'Bonded Zone Release', value: 'BONDED_ZONE_RELEASE' },
        { label: 'Temporary Admission', value: 'TEMPORARY_ADMISSION' },
        { label: 'Re-export', value: 'RE_EXPORT' }
    ];
    procedureStatusOptions = [
        { label: 'Open', value: 'OPEN' },
        { label: 'In Progress', value: 'IN_PROGRESS' },
        { label: 'Pending Closure', value: 'PENDING_CLOSURE' },
        { label: 'Closed', value: 'CLOSED' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    guaranteeTypeOptions = [
        { label: 'Security Deposit', value: 'SECURITY_DEPOSIT' },
        { label: 'Bank Guarantee', value: 'BANK_GUARANTEE' },
        { label: 'Bond', value: 'BOND' },
        { label: 'Cash Deposit', value: 'CASH_DEPOSIT' }
    ];
    guaranteeStatusOptions = [
        { label: 'Active', value: 'ACTIVE' },
        { label: 'Released', value: 'RELEASED' },
        { label: 'Refunded', value: 'REFUNDED' },
        { label: 'Expired', value: 'EXPIRED' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    closureEventTypeOptions = [
        { label: 'Closure Evidence', value: 'CLOSURE_EVIDENCE' },
        { label: 'Exit Confirmed', value: 'EXIT_CONFIRMED' },
        { label: 'Export Permit', value: 'EXPORT_PERMIT' },
        { label: 'Warehouse Release', value: 'WAREHOUSE_RELEASE' },
        { label: 'Customs Completion', value: 'CUSTOMS_COMPLETION' }
    ];
    closureStatusOptions = [
        { label: 'Recorded', value: 'RECORDED' },
        { label: 'Accepted', value: 'ACCEPTED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    integrationInternalStatusOptions = [
        { label: 'OK', value: 'OK' },
        { label: 'Warning', value: 'WARNING' },
        { label: 'Error', value: 'ERROR' },
        { label: 'Pending', value: 'PENDING' },
        { label: 'Missing', value: 'MISSING' }
    ];
    taskPriorityOptions = [
        { label: 'Low', value: 'LOW' },
        { label: 'Normal', value: 'NORMAL' },
        { label: 'High', value: 'HIGH' },
        { label: 'Urgent', value: 'URGENT' }
    ];
    assessmentStatusOptions = [
        { label: 'Assessed', value: 'ASSESSED' },
        { label: 'Paid', value: 'PAID' },
        { label: 'Waived', value: 'WAIVED' },
        { label: 'Bonded', value: 'BONDED' },
        { label: 'Deferred Approved', value: 'DEFERRED_APPROVED' },
        { label: 'Not Applicable', value: 'NOT_APPLICABLE' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    receiptPaymentTypeOptions = [
        { label: 'Import Duty', value: 'IMPORT_DUTY' },
        { label: 'Import VAT', value: 'IMPORT_VAT' },
        { label: 'Customs Duty / VAT', value: 'CUSTOMS_DUTY_VAT' },
        { label: 'Port Outlay', value: 'PORT_OUTLAY' },
        { label: 'Other Fees', value: 'OTHER_FEES' }
    ];
    receiptStatusOptions = [
        { label: 'Paid', value: 'PAID' },
        { label: 'Verified', value: 'VERIFIED' },
        { label: 'Approved', value: 'APPROVED' },
        { label: 'Rejected', value: 'REJECTED' },
        { label: 'Cancelled', value: 'CANCELLED' }
    ];
    productivityTasks: ProductivityTask[] = [];
    productivityIncidents: ProductivityIncident[] = [];
    productivityNotifications: ProductivityNotification[] = [];
    taskDraft: ProductivityTask = { title: '', priority: 'NORMAL', status: 'OPEN' };
    workspaceTabs = [
        { id: 'overview', label: 'Overview', icon: 'pi pi-chart-pie' },
        { id: 'declarations', label: 'Declarations', icon: 'pi pi-file-edit' },
        { id: 'items', label: 'Items', icon: 'pi pi-list' },
        { id: 'documents', label: 'Documents', icon: 'pi pi-folder-open' },
        { id: 'authorization', label: 'Authorization', icon: 'pi pi-shield' },
        { id: 'duties', label: 'Duties & Payments', icon: 'pi pi-wallet' },
        { id: 'containers', label: 'Containers', icon: 'pi pi-box' },
        { id: 'procedures', label: 'GCC Procedures', icon: 'pi pi-sitemap' },
        { id: 'integrations', label: 'Integrations', icon: 'pi pi-cloud' },
        { id: 'links', label: 'Links', icon: 'pi pi-link' },
        { id: 'workflow', label: 'Workflow', icon: 'pi pi-share-alt' },
        { id: 'productivity', label: 'Productivity', icon: 'pi pi-briefcase' },
        { id: 'activity', label: 'Activity', icon: 'pi pi-history' }
    ];

    clearanceHeaderFields: { key: keyof CustomsClearanceHeader, label: string, type: string }[] = [
        { key: 'bl_awb_number', label: 'BL/AWB Number', type: 'string' },
        { key: 'hbl_number', label: 'HBL Number', type: 'string' },
        { key: 'bayanNumber', label: 'Bayan Number', type: 'string' },
        { key: 'deliveryOrderNumber', label: 'Delivery Order Number', type: 'string' },
        { key: 'vesselName', label: 'Vessel Name', type: 'string' },
        { key: 'pol', label: 'Point of Loading', type: 'string' },
        { key: 'pod', label: 'Point of Discharge', type: 'string' },
        { key: 'containers', label: 'Container Number', type: 'string' },
        { key: 'containerType', label: 'Container Type', type: 'string' },
        { key: 'customsLocation', label: 'Customs Location', type: 'string' },
        { key: 'eta', label: 'ETA', type: 'date' },
        { key: 'etd', label: 'ETD', type: 'date' },
        { key: 'clearanceDate', label: 'Clearance Date', type: 'date' },
        { key: 'updatedDate', label: 'Updated Date', type: 'date' },
    ];

    constructor(
        private clearanceService: CustomsClearanceEndpointService,
        private messageService: MessageService,
        private sessionStorageService: SessionStorageService,
        private route: ActivatedRoute,
        private dialogService: DialogService,
        private router: Router, private location: Location,
        private permissionService: PermissionService,
        private productivityService: ProductivityService,
        private firebaseStorageService: FirebaseStorageService,
        private warehousingService: WarehousingService,
        private shipmentService: ShipmentService
    ) {
    }

    ngOnInit(): void {
        this.canEditClearance = this.permissionService.hasPermission(app_permissions.clearance.records.edit);
        this.canCreateClearance = this.permissionService.hasPermission(app_permissions.clearance.records.create);
        this.canUploadFile = this.permissionService.hasPermission(app_permissions.clearance.files.upload);
        this.canManageCharges = this.permissionService.hasPermission(app_permissions.clearance.charges.edit);
        this.canUpdateStatus = this.permissionService.hasPermission(app_permissions.clearance.status.update);
        this.countries = this.sessionStorageService.getCountryList() ?? [];
        this.currencyOptions = this.buildCurrencyOptions();
        this.route.queryParamMap.subscribe(queryParams => {
            this.activeWorkspaceTab = this.resolveWorkspaceTab(queryParams.get('tab'));
        });
        
        this.route.params.subscribe(params => {
            this.clearanceId = params['id'];
            this.loadClearance();
        });
    }

    private buildCurrencyOptions(): { label: string; value: string }[] {
        const currencyMap = new Map<string, string>();
        this.countries
            .filter(country => !!country.currencyCode)
            .forEach(country => currencyMap.set(country.currencyCode, `${country.currencyCode} - ${country.currencyLong || country.name}`));
        if (!currencyMap.size) {
            ['SAR', 'USD', 'EUR', 'AED'].forEach(currency => currencyMap.set(currency, currency));
        }
        return Array.from(currencyMap.entries())
            .map(([value, label]) => ({ label, value }))
            .sort((left, right) => left.value.localeCompare(right.value));
    }

    private loadReferenceOptions(): void {
        this.warehousingService.getMasterData('WAREHOUSE', { activeStatus: 'ACTIVE' }).subscribe({
            next: response => this.warehouseOptions = response.data || [],
            error: () => this.warehouseOptions = []
        });

        const companyId = this.clearance?.owningCompanyId || this.sessionStorageService.getCompany()?.id;
        const params: { [param: string]: string } = companyId ? { owningCompanyId: `${companyId}` } : {};
        this.shipmentService.searchShipments(params, { page: 0, size: 100, sort: 'creationDate,desc' }).subscribe({
            next: page => {
                const currentShipment = this.clearance?.shipment;
                const shipments = page.content || [];
                this.shipmentOptions = currentShipment?.shipmentId && !shipments.some(shipment => shipment.shipmentId === currentShipment.shipmentId)
                    ? [currentShipment, ...shipments]
                    : shipments;
            },
            error: () => this.shipmentOptions = this.clearance?.shipment ? [this.clearance.shipment] : []
        });
    }

    loadClearance() {
        this.isLoading = true;
        this.clearanceService.getCustomsClearanceHeaderById(this.clearanceId).subscribe({
            next: (data) => {
                this.clearance = data;
                this.generatePeople();
                this.loadReferenceOptions();
                this.loadWorkspace();
                this.isLoading = false;
            },
            error: (error) => {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Error loading clearance'
                });
                this.isLoading = false;
            }
        });
    }

    cancel() {
        this.location.back();
    }

    addNewFile() {
        if (!this.canUploadFile) {
            this.messageService.add({ severity: 'warn', summary: 'Permission', detail: 'You do not have permission to upload files.' });
            return;
        }
        this.sessionStorageService.setCurrentClearanceHeader(this.clearance);

        // Define the callback function
        const fileUploadCallback: ClearanceDownloadUrlCallback = (clearanceFile: CustomsClearanceFile) => {
            fileUploadDialog.close();
            this.messageService.add({ severity: 'info', summary: 'Success', detail: 'File Upload Complete' });
            this.clearance.clearanceFiles.push(clearanceFile);
        };

        // Open the dialog with the callback
        let fileUploadDialog = this.dialogService.open(ClearanceFileUploadComponent, {
            header: 'Create/Upload Clearance File',
            width: '50vw',
            modal: true,
            data: { callback: fileUploadCallback },
        });
    }

    activeTabIndex: number = 0; // Added activeTabIndex
    tabChange(event: any) { // Modified tabChange to accept any event and update activeTabIndex
        this.activeTabIndex = event.index;
    }

    addWatcher() {

    }

    sendEmail(emailAddress: string) {

    }

    makePhoneCall(phoneNumber: string) {

    }

    updateSellingPrice(chargeLine: CustomsClearanceDetail) {
        if (!this.canManageCharges) {
            this.messageService.add({ severity: 'warn', summary: 'Permission', detail: 'You do not have permission to update charges.' });
            return;
        }
        this.selectedCharge = chargeLine;
        this.chargeDialogVisible = true;
    }

    updateBuyingPrice(chargeLine: CustomsClearanceDetail) {
        if (!this.canManageCharges) {
            this.messageService.add({ severity: 'warn', summary: 'Permission', detail: 'You do not have permission to update charges.' });
            return;
        }
        this.selectedCharge = chargeLine;
        this.chargeDialogVisible = true;
    }

    addNewChargeLine() {
        this.selectedCharge = undefined;
        this.chargeDialogVisible = true;
    }

    editChargeLine(chargeLine: CustomsClearanceDetail) {
        this.selectedCharge = chargeLine;
        this.chargeDialogVisible = true;
    }

    getTotalBuyingPrice() {
        return (this.clearance.clearanceDetails || []).reduce((total, detail) => total + (detail.buyingAmount ?? 0), 0);
    }

    getTotalSellingPrice() {
        return (this.clearance.clearanceDetails || []).reduce((total, detail) => total + (detail.sellingAmount ?? 0), 0);
    }

    showAsDate(clearanceElement: any) {
        return new Date(clearanceElement).toLocaleDateString();
    }

    private generatePeople() {
        this.people = [];
        this.people.push({
            contact: this.clearance.consigneeContact,
            contactRole: 'CONSIGNEE',
            contactType: UserRole.CUSTOMER
        } as CustomsClearanceContacts);
        this.people.push({
            contact: this.clearance.shipperContact,
            contactRole: 'SHIPPER',
            contactType: UserRole.CUSTOMER
        } as CustomsClearanceContacts);
    }

    onChargeSaved(charge: CustomsClearanceDetail) {
        if (this.selectedCharge) {
            // Update existing charge
            this.clearance.clearanceDetails = this.clearance.clearanceDetails || [];
            const index = this.clearance.clearanceDetails.findIndex(c => c.clearanceDetailID === charge.clearanceDetailID);
            if (index !== -1) {
                this.clearance.clearanceDetails[index] = charge;
            }
        } else {
            // Add new charge
            this.clearance.clearanceDetails = this.clearance.clearanceDetails || [];
            this.clearance.clearanceDetails.push(charge);
        }
    }

    setWorkspaceTab(tabId: string) {
        this.activeWorkspaceTab = this.resolveWorkspaceTab(tabId);
        this.router.navigate([], {
            relativeTo: this.route,
            queryParams: { tab: this.activeWorkspaceTab },
            queryParamsHandling: 'merge',
            replaceUrl: true
        });
    }

    private resolveWorkspaceTab(tabId: string | null): string {
        const normalizedTabId = (tabId === 'tasks' ? 'productivity' : tabId) ?? 'overview';
        return this.workspaceTabs.some(tab => tab.id === normalizedTabId) ? normalizedTabId : 'overview';
    }

    openEntryDialog(dialog: string): void {
        this.activeEntryDialog = dialog;
    }

    onEntryDialogVisibleChange(visible: boolean, dialog: string): void {
        if (visible) {
            this.activeEntryDialog = dialog;
            return;
        }

        if (this.activeEntryDialog === dialog) {
            this.closeEntryDialog();
        }
    }

    closeEntryDialog(): void {
        this.activeEntryDialog = null;
    }

    get workspaceMetrics(): PageMetric[] {
        return [
            { label: 'Readiness', value: this.readiness?.readinessStatus || 'Checking', hint: 'Phase 1 local rules', tone: this.readiness?.readyForFiling ? 'success' : this.readiness?.preClearanceLate ? 'danger' : 'warn' },
            { label: 'Declarations', value: this.declarations.length, hint: 'Bayan / Fasah records', tone: 'info' },
            { label: 'HS Items', value: this.readiness?.itemCount ?? this.declarationItems.length, hint: 'Goods lines', tone: 'info' },
            { label: 'Missing Docs', value: this.readiness?.missingDocumentCount ?? 0, hint: 'Required checklist', tone: (this.readiness?.missingDocumentCount || 0) > 0 ? 'warn' : 'success' },
            { label: 'Outstanding', value: this.formatAmount(this.financialSummary?.outstandingAmount), hint: 'Customs outlay', tone: (this.financialSummary?.outstandingAmount || 0) > 0 ? 'danger' : 'success' },
            { label: 'Unreleased', value: this.executionReadiness?.unreleasedContainerCount ?? 0, hint: 'Containers', tone: (this.executionReadiness?.unreleasedContainerCount || 0) > 0 ? 'warn' : 'success' },
            { label: 'External Errors', value: this.integrationSummary?.errorCount ?? 0, hint: 'KSA providers', tone: (this.integrationSummary?.errorCount || 0) > 0 ? 'danger' : (this.integrationSummary?.warningCount || 0) > 0 ? 'warn' : 'success' },
            { label: 'Productivity', value: this.productivityTasks.length + this.productivityIncidents.length + this.productivityNotifications.length, hint: 'Tasks, incidents, notifications', tone: 'default' }
        ];
    }

    loadWorkspace() {
        if (!this.clearanceId) return;
        this.clearanceService.getWorkspaceSummary(this.clearanceId).subscribe(summary => this.applyWorkspaceSummary(summary));
        this.loadProductivityNotifications();
    }

    selectDeclaration(declaration: CustomsDeclaration) {
        this.selectedDeclaration = declaration;
        this.declarationDraft = { ...declaration };
        this.loadSelectedDeclarationData(declaration.id);
    }

    selectDeclarationFromEvent(event: any) {
        if (event?.data) {
            this.selectDeclaration(event.data as CustomsDeclaration);
        }
    }

    newDeclaration() {
        this.selectedDeclaration = undefined;
        this.declarationDraft = {
            declarationType: 'IMPORT',
            movementType: 'LOCAL_CONSUMPTION',
            transportMode: 'SEA',
            portType: 'SEA',
            paymentMode: 'IMPORTER_ACCOUNT',
            customsStatus: 'DRAFT',
            fasahStatus: 'NOT_SUBMITTED'
        };
        this.declarationItems = [];
        this.openEntryDialog('declaration');
    }

    saveDeclaration() {
        this.clearanceService.saveDeclaration(this.clearanceId, this.declarationDraft).subscribe({
            next: declaration => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Declaration saved' });
                this.selectedDeclaration = declaration;
                this.declarationDraft = { ...declaration };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save declaration' })
        });
    }

    saveItem() {
        if (!this.selectedDeclaration?.id) {
            this.messageService.add({ severity: 'warn', summary: 'Declaration required', detail: 'Save/select a declaration first' });
            return;
        }
        const itemPayload: CustomsDeclarationItem = {
            ...this.itemDraft,
            restrictedGoods: !!this.itemDraft.restrictedGoods,
            permitRequired: !!this.itemDraft.permitRequired,
            saberRequired: !!this.itemDraft.saberRequired,
            inspectionRequired: !!this.itemDraft.inspectionRequired
        };
        this.clearanceService.saveDeclarationItem(this.selectedDeclaration.id, itemPayload).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Item saved' });
                this.itemDraft = this.newItemDraft();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save item' })
        });
    }

    editItem(item: CustomsDeclarationItem) {
        this.itemDraft = { ...item };
        this.activeWorkspaceTab = 'items';
        this.openEntryDialog('item');
    }

    newItem() {
        this.itemDraft = this.newItemDraft();
        this.openEntryDialog('item');
    }

    private newItemDraft(): CustomsDeclarationItem {
        return {
            currencyCode: 'SAR',
            restrictedGoods: false,
            permitRequired: false,
            saberRequired: false,
            inspectionRequired: false
        };
    }

    generateDocuments() {
        this.clearanceService.generateDefaultComplianceDocuments(this.clearanceId).subscribe(docs => {
            this.complianceDocuments = docs;
            this.loadWorkspace();
        });
    }

    saveDocument() {
        const documentPayload: CustomsComplianceDocument = {
            ...this.documentDraft,
            documentType: this.documentDraft.documentType || 'OTHER',
            required: this.documentDraft.required !== false,
            translationRequired: !!this.documentDraft.translationRequired,
            status: this.documentDraft.fileId ? 'UPLOADED' : 'MISSING'
        };
        this.clearanceService.saveComplianceDocument(this.clearanceId, documentPayload).subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Document checklist updated' });
            this.documentDraft = this.newDocumentDraft();
            this.closeEntryDialog();
            this.loadWorkspace();
        });
    }

    editDocument(document: CustomsComplianceDocument) {
        this.documentDraft = { ...document };
        this.openEntryDialog('document');
    }

    newDocument() {
        this.documentDraft = this.newDocumentDraft();
        this.openEntryDialog('document');
    }

    private newDocumentDraft(): CustomsComplianceDocument {
        return {
            required: true,
            status: 'MISSING',
            translationRequired: false
        };
    }

    documentFile(document: CustomsComplianceDocument = this.documentDraft): CustomsClearanceFile | undefined {
        return (this.clearance?.clearanceFiles || []).find(file => file.fileId === document.fileId);
    }

    documentFileType(document: CustomsComplianceDocument = this.documentDraft): string {
        const documentType = (document.documentType || '').toUpperCase();
        const exact = this.customsClearanceFileTypes.find(type => type.value === documentType);
        if (exact) return exact.value;
        if (documentType.includes('COMMERCIAL') && documentType.includes('INVOICE')) return 'COMMERCIAL_INVOICE';
        if (documentType.includes('INVOICE')) return 'INVOICE';
        if (documentType.includes('PACKING')) return 'PACKING_LIST';
        if (documentType.includes('BL_AWB') || documentType.includes('BL/AWB')) return 'BL';
        if (documentType.includes('AWB')) return 'AWB';
        if (documentType.includes('BL')) return 'BL';
        if (documentType.includes('EXPORT') && documentType.includes('PERMIT')) return 'EXPORT_PERMIT';
        if (documentType.includes('IMPORT') && documentType.includes('PERMIT')) return 'IMPORT_PERMIT';
        if (documentType.includes('CERTIFICATE') && documentType.includes('ORIGIN')) return 'CERTIFICATE_OF_ORIGIN';
        if (documentType.includes('AUTH')) return 'AUTHORIZATION';
        return 'DOCUMENT';
    }

    documentFileTypeLabel(document: CustomsComplianceDocument = this.documentDraft): string {
        const fileType = this.documentFileType(document);
        return this.customsClearanceFileTypes.find(type => type.value === fileType)?.label || fileType;
    }

    documentTypeLabel(document: CustomsComplianceDocument): string {
        if (!document.documentType) return 'Document';
        return this.customsClearanceFileTypes.find(type => type.value === document.documentType)?.label
            || document.documentType.replace(/_/g, ' ');
    }

    documentPresenceStatus(document: CustomsComplianceDocument): string {
        return document.fileId ? 'UPLOADED' : 'MISSING';
    }

    receiptDocumentOptions(): CustomsClearanceFile[] {
        return this.clearance?.clearanceFiles || [];
    }

    receiptDocumentLabel(file: CustomsClearanceFile): string {
        const typeLabel = this.customsClearanceFileTypes.find(type => type.value === file.fileType)?.label
            || file.fileType
            || 'Document';
        return `${typeLabel} - ${file.fileName || 'Unnamed file'}`;
    }

    receiptAssessmentLabel(assessment: CustomsDutyTaxAssessment): string {
        const reference = assessment.assessmentReferenceNo || `Assessment #${assessment.id}`;
        const amount = this.formatAmount(assessment.totalAssessmentAmount, assessment.currencyCode || 'SAR');
        return `${reference} - ${amount}`;
    }

    clearanceDocumentOptions(): CustomsClearanceFile[] {
        return this.clearance?.clearanceFiles || [];
    }

    clearanceDocumentLabel(file?: CustomsClearanceFile): string {
        if (!file) return 'Select evidence document';
        return this.receiptDocumentLabel(file);
    }

    declarationOptionLabel(declaration?: CustomsDeclaration): string {
        if (!declaration) return 'Select declaration';
        return declaration.declarationNo
            || declaration.declarationReferenceNo
            || declaration.bayanNumber
            || `Declaration #${declaration.id}`;
    }

    shipmentOptionLabel(shipment?: Shipment): string {
        if (!shipment) return 'Select shipment';
        return shipment.shipmentNumber
            || shipment.externalReference
            || `Shipment #${shipment.shipmentId}`;
    }

    warehouseOptionLabel(warehouse?: WarehousingMasterData): string {
        if (!warehouse) return 'Select warehouse';
        return warehouse.code ? `${warehouse.name} - ${warehouse.code}` : warehouse.name;
    }

    clearanceDocumentLabelById(fileId?: number): string {
        if (!fileId) return '-';
        return this.clearanceDocumentLabel(this.clearanceDocumentOptions().find(file => file.fileId === fileId));
    }

    declarationLabelById(declarationId?: number): string {
        if (!declarationId) return '-';
        return this.declarationOptionLabel(this.declarations.find(declaration => declaration.id === declarationId));
    }

    shipmentLabelById(shipmentId?: number): string {
        if (!shipmentId) return '-';
        const shipment = this.shipmentOptions.find(option => option.shipmentId === shipmentId)
            || (this.clearance?.shipmentId === shipmentId ? this.clearance.shipment : undefined);
        return this.shipmentOptionLabel(shipment);
    }

    warehouseLabelById(warehouseId?: number): string {
        if (!warehouseId) return '-';
        return this.warehouseOptionLabel(this.warehouseOptions.find(warehouse => warehouse.id === warehouseId));
    }

    removeDocumentFile(): void {
        const fileId = this.documentDraft.fileId;
        if (!fileId) {
            this.documentDraft.status = 'MISSING';
            return;
        }

        this.clearanceService.deleteCustomsClearanceFile(fileId).subscribe({
            next: () => {
                this.clearance.clearanceFiles = (this.clearance.clearanceFiles || []).filter(file => file.fileId !== fileId);
                this.documentDraft.fileId = undefined;
                this.documentDraft.status = 'MISSING';
                this.messageService.add({ severity: 'info', summary: 'Removed', detail: 'Document file removed from checklist item.' });
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Remove Failed', detail: 'Could not remove document file.' })
        });
    }

    onDocumentFileUpload(event: any): void {
        const file: File = event.files?.[0];
        if (!file) return;
        if (!this.canUploadFile) {
            this.messageService.add({ severity: 'warn', summary: 'Permission', detail: 'You do not have permission to upload files.' });
            return;
        }

        const fileType = this.documentFileType();
        const storageFileName = `${Date.now()}_${file.name}`;
        this.firebaseStorageService.uploadFileWithProgress(file, `clearance-files/${storageFileName}`).subscribe({
            next: upload => {
                this.documentUploadProgress = upload.progress;
                if (!upload.url) return;

                const customerId = this.sessionStorageService.getCustomer()?.id;
                const clearanceFile: CustomsClearanceFile = {
                    headerId: this.clearanceId,
                    fileType,
                    fileName: storageFileName,
                    fileSize: file.size,
                    fileUrl: upload.url,
                    createdAt: new Date(),
                    createdBy: customerId,
                    updatedAt: new Date(),
                    updatedBy: customerId
                };

                this.clearanceService.createCustomsClearanceFile(clearanceFile).subscribe({
                    next: savedFile => {
                        this.clearance.clearanceFiles = [
                            ...((this.clearance.clearanceFiles || []).filter(existing => existing.fileId !== this.documentDraft.fileId)),
                            savedFile
                        ];
                        this.documentDraft.fileId = savedFile.fileId;
                        this.documentDraft.status = 'UPLOADED';
                        this.documentUploadProgress = 0;
                        this.messageService.add({ severity: 'success', summary: 'Uploaded', detail: `${file.name} uploaded.` });
                    },
                    error: () => {
                        this.documentUploadProgress = 0;
                        this.messageService.add({ severity: 'error', summary: 'Save Failed', detail: 'File uploaded, but could not be linked to clearance.' });
                    }
                });
            },
            error: err => {
                this.documentUploadProgress = 0;
                this.messageService.add({ severity: 'error', summary: 'Upload Failed', detail: `${file.name} could not be uploaded: ${err.message || 'Unknown error'}` });
            }
        });
    }

    saveAuthorization() {
        this.clearanceService.saveBrokerAuthorization(this.clearanceId, this.authorizationDraft).subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Authorization saved' });
            this.authorizationDraft = { status: 'ACTIVE', source: 'MANUAL' };
            this.closeEntryDialog();
            this.loadWorkspace();
        });
    }

    editAuthorization(authorization: CustomsBrokerAuthorization) {
        this.authorizationDraft = { ...authorization };
        this.openEntryDialog('authorization');
    }

    newAuthorization() {
        this.authorizationDraft = { status: 'ACTIVE', source: 'MANUAL' };
        this.openEntryDialog('authorization');
    }

    newProcedureCase(mode: string = 'GCC_TRANSIT') {
        this.procedureDraft = {
            procedureMode: mode,
            declarationId: this.selectedDeclaration?.id,
            relatedShipmentId: this.clearance?.shipmentId || this.clearance?.shipment?.shipmentId,
            status: 'OPEN',
            closureStatus: 'OPEN'
        };
        this.selectedProcedureCase = undefined;
        this.openEntryDialog('procedure');
    }

    selectProcedureCase(procedureCase?: CustomsProcedureCase | CustomsProcedureCase[]) {
        if (!procedureCase || Array.isArray(procedureCase)) {
            return;
        }
        this.selectedProcedureCase = procedureCase;
        this.procedureDraft = { ...procedureCase };
        this.guaranteeDraft = {
            procedureCaseId: procedureCase.id,
            declarationId: procedureCase.declarationId,
            guaranteeType: this.defaultGuaranteeType(procedureCase.procedureMode),
            currencyCode: 'SAR',
            status: 'ACTIVE'
        };
        this.closureEventDraft = {
            procedureCaseId: procedureCase.id,
            declarationId: procedureCase.declarationId,
            eventType: this.defaultClosureEventType(procedureCase.procedureMode),
            status: 'RECORDED'
        };
    }

    saveProcedureCase() {
        this.clearanceService.saveProcedureCase(this.clearanceId, this.procedureDraft).subscribe({
            next: saved => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'GCC procedure case saved' });
                this.selectedProcedureCase = saved;
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save procedure case' })
        });
    }

    saveGuaranteeDeposit() {
        const procedureCaseId = this.selectedProcedureCase?.id || this.guaranteeDraft.procedureCaseId;
        if (!procedureCaseId) {
            this.messageService.add({ severity: 'warn', summary: 'Procedure required', detail: 'Save or select a GCC procedure first' });
            return;
        }
        this.guaranteeDraft.procedureCaseId = procedureCaseId;
        this.clearanceService.saveGuaranteeDeposit(this.clearanceId, this.guaranteeDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Guarantee/deposit saved' });
                this.guaranteeDraft = { procedureCaseId, guaranteeType: 'SECURITY_DEPOSIT', currencyCode: 'SAR', status: 'ACTIVE' };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save guarantee/deposit' })
        });
    }

    saveClosureEvent() {
        const procedureCaseId = this.selectedProcedureCase?.id || this.closureEventDraft.procedureCaseId;
        if (!procedureCaseId) {
            this.messageService.add({ severity: 'warn', summary: 'Procedure required', detail: 'Save or select a GCC procedure first' });
            return;
        }
        this.closureEventDraft.procedureCaseId = procedureCaseId;
        this.clearanceService.saveProcedureClosureEvent(this.clearanceId, procedureCaseId, this.closureEventDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Closure event saved' });
                this.closureEventDraft = { procedureCaseId, eventType: 'CLOSURE_EVIDENCE', status: 'RECORDED' };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save closure event' })
        });
    }

    saveRelatedResource() {
        this.clearanceService.saveRelatedResource(this.clearanceId, this.relatedResourceDraft).subscribe(() => {
            this.messageService.add({ severity: 'success', summary: 'Linked', detail: 'Related resource saved' });
            this.relatedResourceDraft = {};
            this.loadWorkspace();
        });
    }

    get procedureModeCards() {
        return [
            { mode: 'GCC_TRANSIT', label: 'GCC Transit', hint: 'Saudi entry/exit and guarantee closure' },
            { mode: 'BONDED_ZONE_ENTRY', label: 'Bonded Zone', hint: 'Suspended duty warehouse handoff' },
            { mode: 'TEMPORARY_ADMISSION', label: 'Temporary Admission', hint: 'Deposit with re-export closure' },
            { mode: 'RE_EXPORT', label: 'Re-export', hint: 'Export evidence and deposit release' }
        ];
    }

    procedureCasesFor(mode: string): CustomsProcedureCase[] {
        return this.procedureCases.filter(item => item.procedureMode === mode);
    }

    guaranteesFor(procedureCaseId?: number): CustomsGuaranteeDeposit[] {
        return this.guaranteeDeposits.filter(item => item.procedureCaseId === procedureCaseId);
    }

    closureEventsFor(procedureCaseId?: number): CustomsProcedureClosureEvent[] {
        return this.closureEvents.filter(item => item.procedureCaseId === procedureCaseId);
    }

    defaultGuaranteeType(mode?: string): string {
        switch (mode) {
            case 'GCC_TRANSIT': return 'TRANSIT_GUARANTEE';
            case 'BONDED_ZONE_ENTRY': return 'BOND_GUARANTEE';
            case 'TEMPORARY_ADMISSION': return 'SECURITY_DEPOSIT';
            case 'RE_EXPORT': return 'RE_EXPORT_GUARANTEE';
            default: return 'SECURITY_DEPOSIT';
        }
    }

    defaultClosureEventType(mode?: string): string {
        switch (mode) {
            case 'GCC_TRANSIT': return 'TRANSIT_EXIT';
            case 'BONDED_ZONE_ENTRY': return 'BONDED_ADMISSION';
            case 'BONDED_ZONE_RELEASE': return 'BONDED_RELEASE';
            case 'TEMPORARY_ADMISSION': return 'TEMPORARY_ADMISSION_RE_EXPORT';
            case 'RE_EXPORT': return 'RE_EXPORT';
            default: return 'CLOSURE_EVIDENCE';
        }
    }

    saveAssessment() {
        if (!this.selectedDeclaration?.id) {
            this.messageService.add({ severity: 'warn', summary: 'Declaration required', detail: 'Save/select a declaration first' });
            return;
        }
        this.clearanceService.saveDutyTaxAssessment(this.selectedDeclaration.id, this.assessmentDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Duty/tax assessment saved' });
                this.assessmentDraft = { currencyCode: 'SAR', assessmentStatus: 'ASSESSED', paymentMode: 'IMPORTER_ACCOUNT' };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save assessment' })
        });
    }

    editAssessment(assessment: CustomsDutyTaxAssessment) {
        this.assessmentDraft = { ...assessment };
        this.openEntryDialog('assessment');
    }

    newAssessment() {
        this.assessmentDraft = { currencyCode: 'SAR', assessmentStatus: 'ASSESSED', paymentMode: 'IMPORTER_ACCOUNT' };
        this.openEntryDialog('assessment');
    }

    savePaymentReceipt() {
        this.clearanceService.savePaymentReceipt(this.clearanceId, this.receiptDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Payment receipt saved' });
                this.receiptDraft = { currencyCode: 'SAR', paymentType: 'IMPORT_DUTY', status: 'PAID' };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save receipt' })
        });
    }

    editPaymentReceipt(receipt: CustomsPaymentReceipt) {
        this.receiptDraft = { ...receipt };
        this.openEntryDialog('receipt');
    }

    newPaymentReceipt() {
        this.receiptDraft = { currencyCode: 'SAR', paymentType: 'IMPORT_DUTY', status: 'PAID' };
        this.openEntryDialog('receipt');
    }

    saveContainer() {
        this.clearanceService.saveCustomsContainer(this.clearanceId, this.containerDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Container release record saved' });
                this.containerDraft = { customsReleaseStatus: 'PENDING', lineStatus: 'PENDING' };
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save container' })
        });
    }

    editContainer(container: CustomsContainer) {
        this.containerDraft = { ...container };
        this.activeWorkspaceTab = 'containers';
        this.openEntryDialog('container');
    }

    newContainer() {
        this.containerDraft = { customsReleaseStatus: 'PENDING', lineStatus: 'PENDING' };
        this.openEntryDialog('container');
    }

    generateContainersFromHeader() {
        this.clearanceService.generateCustomsContainersFromHeader(this.clearanceId).subscribe({
            next: containers => {
                this.customsContainers = containers;
                this.messageService.add({ severity: 'success', summary: 'Generated', detail: 'Container records generated from header' });
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not generate containers' })
        });
    }

    getIntegrationStatus(providerKey: string): CustomsIntegrationStatus | undefined {
        return this.integrationStatuses.find(status => (status.provider || '').toUpperCase() === providerKey);
    }

    newIntegrationStatus(providerKey: string = 'FASAH') {
        this.integrationDraft = {
            provider: providerKey,
            externalStatus: 'DRAFT',
            internalStatus: 'WARNING',
            active: true,
            retryCount: 0
        };
        this.openEntryDialog('integration');
    }

    editIntegrationStatus(status: CustomsIntegrationStatus) {
        this.integrationDraft = { ...status };
        this.activeWorkspaceTab = 'integrations';
        this.openEntryDialog('integration');
    }

    saveIntegrationStatus() {
        this.clearanceService.saveIntegrationStatus(this.clearanceId, this.integrationDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Saved', detail: 'Integration status saved' });
                this.newIntegrationStatus(this.integrationDraft.provider || 'FASAH');
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not save integration status' })
        });
    }

    manualIntegrationStatusUpdate() {
        if (!this.integrationDraft.id) {
            this.saveIntegrationStatus();
            return;
        }
        this.clearanceService.updateManualIntegrationStatus(this.integrationDraft.id, this.integrationDraft).subscribe({
            next: () => {
                this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Manual integration status updated' });
                this.closeEntryDialog();
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not update integration status' })
        });
    }

    refreshIntegrationStatus(status: CustomsIntegrationStatus) {
        if (!status.id) return;
        this.clearanceService.refreshIntegrationStatus(status.id).subscribe({
            next: () => {
                this.messageService.add({ severity: 'info', summary: 'Refresh recorded', detail: 'Manual-mode refresh event recorded' });
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not refresh integration status' })
        });
    }

    createTask() {
        if (!this.taskDraft.title) return;
        this.productivityService.saveTask({
            ...this.taskDraft,
            resourceKey: 'CUSTOMS_CLEARANCE',
            resourceId: this.clearanceId,
            assignedCustomerId: this.taskDraft.assignedCustomerId || this.productivityService.getCustomerId()
        }).subscribe(() => {
            this.taskDraft = { title: '', priority: 'NORMAL', status: 'OPEN' };
            this.closeEntryDialog();
            this.productivityService.refreshSummary();
            this.loadWorkspace();
        });
    }

    newTask() {
        this.taskDraft = { title: '', priority: 'NORMAL', status: 'OPEN' };
        this.openEntryDialog('task');
    }

    getReadinessSeverity() {
        if (this.readiness?.readyForFiling) return 'success';
        if (this.readiness?.preClearanceLate) return 'danger';
        if (this.readiness?.preClearanceAtRisk) return 'warn';
        return 'info';
    }

    getDocumentSeverity(status?: string) {
        const value = (status || '').toUpperCase();
        if (value === 'VERIFIED' || value === 'UPLOADED') return 'success';
        if (value === 'REJECTED' || value === 'MISSING') return 'danger';
        return 'warn';
    }

    getExecutionSeverity() {
        return this.executionReadiness?.readyForCompletion ? 'success' : 'danger';
    }

    getContainerSeverity(status?: string) {
        const value = (status || '').toUpperCase();
        if (value === 'RELEASED' || value === 'CLEARED') return 'success';
        if (value === 'HOLD' || value === 'BLOCKED' || value === 'REJECTED') return 'danger';
        return 'warning';
    }

    getAssessmentSeverity(status?: string) {
        const value = (status || '').toUpperCase();
        if (['PAID', 'WAIVED', 'BONDED', 'DEFERRED_APPROVED', 'SECURED'].includes(value)) return 'success';
        if (value === 'REJECTED' || value === 'DISPUTED') return 'danger';
        return 'warning';
    }

    getIntegrationSeverity(status?: CustomsIntegrationStatus | string) {
        const value = typeof status === 'string'
            ? status.toUpperCase()
            : ((status?.errorCode || status?.errorMessage) ? 'ERROR' : (status?.externalStatus || status?.internalStatus || '')).toUpperCase();
        if (['RELEASED', 'CLEARED', 'ACCEPTED', 'VERIFIED', 'CHECKED', 'APPROVED', 'VALID', 'HEALTHY'].includes(value)) return 'success';
        if (['ERROR', 'FAILED', 'REJECTED', 'BLOCKED'].includes(value)) return 'danger';
        return 'warning';
    }

    formatAmount(value?: number | null, currency: string = 'SAR'): string {
        return new Intl.NumberFormat('en-SA', { style: 'currency', currency }).format(Number(value || 0));
    }

    navigateToShipment(shipmentId?: number) {
        shipmentId = shipmentId || this.clearance?.shipmentId || this.clearance?.shipment?.shipmentId;
        if (shipmentId) {
            this.router.navigate(['/shipment/view', shipmentId]);
        }
    }

    navigateToContainerTracking(jobId?: number) {
        this.router.navigate(['/container-tracking/cases']);
    }

    navigateToContainerCase(caseId?: number) {
        if (caseId) {
            this.router.navigate(['/container-tracking/cases/view', caseId]);
        }
    }

    navigateToWarehouse(warehouseId?: number) {
        if (warehouseId) {
            this.router.navigate(['/setup/warehouses/view', warehouseId]);
        }
    }

    navigateToAccounting(link: ClearanceAccountingLink) {
        if (link.invoiceId) {
            this.router.navigate(['/accounts/enterprise/receivables/generated-invoices'], { queryParams: { invoiceId: link.invoiceId } });
            return;
        }
        if (link.receivableId) {
            this.router.navigate(['/accounts/enterprise/receivables/to-be-invoiced'], { queryParams: { receivableId: link.receivableId } });
            return;
        }
        if (link.billId) {
            this.router.navigate(['/accounts/enterprise/payables/generated-bills'], { queryParams: { billId: link.billId } });
            return;
        }
        if (link.payableId) {
            this.router.navigate(['/accounts/enterprise/payables/to-be-billed'], { queryParams: { payableId: link.payableId } });
        }
    }

    navigateToTypedLink(link: ClearanceTypedModuleLink) {
        if (!link.route) return;
        if (link.moduleKey === 'ACCOUNTS_RECEIVABLE' && link.resourceId) {
            this.router.navigate([link.route], { queryParams: { receivableId: link.resourceId } });
            return;
        }
        if (link.moduleKey === 'INVOICE' && link.resourceId) {
            this.router.navigate([link.route], { queryParams: { invoiceId: link.resourceId } });
            return;
        }
        if (link.moduleKey === 'ACCOUNTS_PAYABLE' && link.resourceId) {
            this.router.navigate([link.route], { queryParams: { payableId: link.resourceId } });
            return;
        }
        if (link.moduleKey === 'BILL' && link.resourceId) {
            this.router.navigate([link.route], { queryParams: { billId: link.resourceId } });
            return;
        }
        this.router.navigate([link.route]);
    }

    linkShipment() {
        if (!this.shipmentLinkDraft) return;
        this.clearanceService.linkShipment(this.clearanceId, this.shipmentLinkDraft).subscribe({
            next: links => {
                this.moduleLinks = links;
                this.clearance.shipmentId = this.shipmentLinkDraft;
                this.messageService.add({ severity: 'success', summary: 'Linked', detail: 'Shipment linked to clearance' });
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not link shipment' })
        });
    }

    generatePayables() {
        this.clearanceService.generatePayables(this.clearanceId).subscribe({
            next: links => {
                this.accountingLinks = links;
                this.messageService.add({ severity: 'success', summary: 'Generated', detail: 'Clearance payables generated' });
                this.loadWorkspace();
            },
            error: error => this.messageService.add({
                severity: 'error',
                summary: 'Payables not generated',
                detail: error?.error?.message || error?.message || 'Could not generate payables'
            })
        });
    }

    syncProductivity() {
        this.clearanceService.syncProductivity(this.clearanceId).subscribe({
            next: links => {
                this.moduleLinks = links;
                this.productivityService.refreshSummary();
                this.loadProductivityNotifications();
                this.messageService.add({ severity: 'success', summary: 'Synced', detail: 'Productivity tasks and incidents synced' });
                this.loadWorkspace();
            },
            error: () => this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Could not sync productivity' })
        });
    }

    get workflowContext(): Record<string, unknown> {
        return {
            readyForFiling: !!this.readiness?.readyForFiling,
            readyForCompletion: !!this.executionReadiness?.readyForCompletion,
            missingDocumentCount: this.readiness?.missingDocumentCount || 0,
            declarationCount: this.readiness?.declarationCount || 0,
            blockerCount: this.executionReadiness?.blockers?.length || this.readiness?.blockers?.length || 0,
            outstandingAmount: this.financialSummary?.outstandingAmount || 0,
            containerCount: this.executionReadiness?.containerCount || this.customsContainers.length,
            unreleasedContainerCount: this.executionReadiness?.unreleasedContainerCount || 0
        };
    }

    get linkedShipmentId(): number | undefined {
        return this.clearance?.shipmentId || this.clearance?.shipment?.shipmentId;
    }

    hasLogisticsProject(): boolean {
        return !!this.clearance?.logisticsProjectId;
    }

    openProject(): void {
        if (!this.clearance?.logisticsProjectId) {
            return;
        }
        this.router.navigate(['/logistics-projects', this.clearance.logisticsProjectId]);
    }

    get linkedContainerCaseIds(): number[] {
        const ids = this.customsContainers
            .map(container => container.containerCaseId)
            .filter((id): id is number => !!id);
        return Array.from(new Set(ids));
    }

    get shipmentReference(): string {
        const shipmentLink = this.moduleLinks?.links?.find(link => link.moduleKey === 'SHIPMENT');
        return shipmentLink?.referenceNumber
            || shipmentLink?.label
            || this.clearance?.shipment?.shipmentNumber
            || 'Not linked';
    }

    get linkedWarehouses(): number[] {
        const ids = this.procedureCases
            .map(procedureCase => procedureCase.bondedWarehouseId)
            .filter((id): id is number => !!id);
        return Array.from(new Set(ids));
    }

    private applyWorkspaceSummary(summary: ClearanceWorkspaceSummary) {
        this.readiness = summary.readiness;
        this.declarations = summary.declarations || [];
        this.complianceDocuments = summary.complianceDocuments || [];
        this.brokerAuthorizations = summary.brokerAuthorizations || [];
        this.activity = summary.activity || [];
        this.relatedResources = summary.relatedResources || [];
        this.procedureCases = summary.procedureCases || [];
        this.guaranteeDeposits = summary.guaranteeDeposits || [];
        this.closureEvents = summary.closureEvents || [];
        this.accountingLinks = summary.accountingLinks || [];
        this.moduleLinks = summary.moduleLinks;
        this.financialSummary = summary.financialSummary;
        this.executionReadiness = summary.executionReadiness;
        this.paymentReceipts = summary.paymentReceipts || [];
        this.customsContainers = summary.customsContainers || [];
        this.integrationStatuses = summary.integrationStatuses || [];
        this.integrationEvents = summary.integrationEvents || [];
        this.integrationSummary = summary.integrationSummary;
        this.productivityTasks = summary.productivityTasks || [];
        this.productivityIncidents = summary.productivityIncidents || [];

        this.syncSelectedDeclaration();
        this.syncSelectedProcedureCase();
    }

    private syncSelectedDeclaration() {
        if (!this.declarations.length) {
            this.selectedDeclaration = undefined;
            this.declarationItems = [];
            this.dutyTaxAssessments = [];
            return;
        }

        const selectedId = this.selectedDeclaration?.id;
        const declaration = (selectedId
            ? this.declarations.find(item => item.id === selectedId)
            : undefined) || this.declarations[0];

        if (!declaration) {
            this.selectedDeclaration = undefined;
            this.declarationItems = [];
            this.dutyTaxAssessments = [];
            return;
        }

        this.selectedDeclaration = declaration;
        this.declarationDraft = { ...declaration };
        this.loadSelectedDeclarationData(declaration.id);
    }

    private loadSelectedDeclarationData(declarationId?: number) {
        if (!declarationId) {
            this.declarationItems = [];
            this.dutyTaxAssessments = [];
            return;
        }

        forkJoin({
            items: this.clearanceService.getDeclarationItems(declarationId),
            assessments: this.clearanceService.getDutyTaxAssessments(declarationId)
        }).subscribe(({ items, assessments }) => {
            if (this.selectedDeclaration?.id !== declarationId) {
                return;
            }
            this.declarationItems = items;
            this.dutyTaxAssessments = assessments;
        });
    }

    private syncSelectedProcedureCase() {
        if (!this.procedureCases.length) {
            this.selectedProcedureCase = undefined;
            return;
        }

        const selectedId = this.selectedProcedureCase?.id;
        const procedureCase = (selectedId
            ? this.procedureCases.find(item => item.id === selectedId)
            : undefined) || this.procedureCases[0];

        this.selectProcedureCase(procedureCase);
    }

    private loadProductivityNotifications(): void {
        this.productivityService.getNotifications(false).subscribe({
            next: response => {
                this.productivityNotifications = (response.data || []).filter(notification =>
                    notification.resourceKey === 'CUSTOMS_CLEARANCE' && Number(notification.resourceId) === Number(this.clearanceId)
                );
            },
            error: () => {
                this.productivityNotifications = [];
            }
        });
    }


    changeStatus(status: string) {
        this.isLoading = true;
        const previousStatus = this.clearance.status;
        this.clearance.status = status as ClearanceStatus;
        this.clearanceService.updateCustomsClearanceHeader(this.clearanceId, this.clearance).subscribe({
            next: (data) => {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Confirmed',
                    detail: 'Clearance is Confirmed!'
                })
                this.isLoading = false;
            },
            error: (error) => {
                this.clearance.status = previousStatus;
                const blockerMessage = error?.error?.message || error?.message || 'Error updating clearance';
                this.messageService.add({
                    severity: 'error',
                    summary: 'Completion Blocked',
                    detail: blockerMessage
                });
                this.loadWorkspace();
                this.isLoading = false;
            }
        });
    }

    getStatusSeverity(status: string): string {
        switch (status) {
            case ClearanceStatus.COMPLETED:
            case ClearanceStatus.DELIVERED:
                return 'success';
            case ClearanceStatus.DRAFT:
            case ClearanceStatus.DOCS_REVIEW_IN_PROGRESS:
            case ClearanceStatus.CUSTOMS_FILING_IN_PROGRESS:
            case ClearanceStatus.OUT_FOR_DELIVERY:
                return 'info';
            case ClearanceStatus.REQUEST_SUBMITTED:
            case ClearanceStatus.REQUEST_ACCEPTED:
            case ClearanceStatus.DOCS_UPLOADED:
            case ClearanceStatus.DOCS_REVIEW_COMPLETED:
            case ClearanceStatus.CUSTOMS_FILING_COMPLETED:
            case ClearanceStatus.CUSTOMS_INSPECTION:
            case ClearanceStatus.PORT_CHARGES_PENDING:
            case ClearanceStatus.PORT_CHARGES_PAID:
            case ClearanceStatus.DELIVERY_ORDER_RECEIVED:
                return 'warn';
            case ClearanceStatus.CANCELLED:
            case ClearanceStatus.REQUEST_REJECTED:
            case ClearanceStatus.DOCS_REVIEW_REJECTED:
                return 'danger';
            default: return 'primary';
        }
    }

    protected readonly ClearanceStatus = ClearanceStatus;
}
